<template>
  <div>
    <div v-if="isPC" class="w">
      <div class="tutorial-detail">
      <h1 style="text-align:center">{{tutorialDetail.title}}</h1>
      <iframe v-if="tutorialDetail.videoPath&&tutorialDetail.videoPath!==''" width="100%" height="100%" :src="tutorialDetail.videoPath" :title="$t('Home.helpCenter.MobileTutorialDetail.YouTubeVideoPlayer')" frameborder="0" allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture" allowfullscreen></iframe>
      <div v-html="tutorialDetail.content"></div>
    </div>
    </div>
    <div v-else style="padding-top:1rem">
    <div class="back bg-white f--c"  @click="$router.go(-1)">
      <i class="iconfont icon-a-arrow-left-s-line2"></i>
      <span>{{ $t('Home.helpCenter.MobileTutorialDetail.Tutorial') }}</span>
    </div>
    <div class="tutorial-detail">
      <h1 v-html="tutorialDetail.title"></h1>
      <iframe v-if="tutorialDetail.videoPath&&tutorialDetail.videoPath!==''" width="100%" height="200" :src="tutorialDetail.videoPath" :title="$t('Home.helpCenter.MobileTutorialDetail.YouTubeVideoPlayer')" frameborder="0" allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture" allowfullscreen></iframe>
      <div style="margin-top:0.2rem" v-html="tutorialDetail.content"></div>
    </div>
  </div>
  </div>
</template>

<script>
export default {
  data() {
    return {
      tutorialDetail: {}
    }
  },
  created() {
    console.log(this.$route.query.content)
    this.tutorialDetail = JSON.parse(this.$route.query.content)
    this.tutorialDetail.content = this.getContent(JSON.parse(this.$route.query.content))
    console.log(this.tutorialDetail.videoPath)
  },
  methods: {
    getContent(data) {
      let contents = data.content.replaceAll('margin-left: 21pt; text-indent: -21pt;', '')
      let r = RegExp(/<[img]+\s+(.*?)(?<id>\w*?)[\s'"](.*?)>/g)
      let matchres = contents.match(r)// 返回数组['<img ... />','<img ... />']
      let imgList = []
      data.content.replace(/<img [^>]*src=['"]([^'"]+)[^>]*>/g, (match, capture) => {
        imgList.push(capture)
      })
      if (matchres) {
        matchres.forEach((item, index) => {
          let _str = `<img src="${imgList[index]}" alt='' lazy style="max-width:100%;margin:0 auto;"/>`
          contents = contents.replace(item, _str)
          contents = contents.replaceAll('margin-left: 42pt; text-indent: -42pt;', '')
        })
      }
      return contents
    }
  }
}
</script>

<style lang="scss" scoped>
.tutorial-detail {
  padding: 0.6rem 0.32rem 0.2rem;
  min-height: 100vh;
  h1 {
    padding-top: 0.4rem;
    padding-bottom: 0.2rem;
    font-weight: 500;
    font-size: 0.36rem;
  }
  div {
    font-size: 0.28rem;
    line-height: 0.42rem;
    color: #4f4f4f;
  }
}
.back {
  position: fixed;
  width: 100%;
  top: 0.9rem;
  padding-top: 0.15rem;
  i {
    font-size: 0.5rem;
  }
  span {
    font-size: 0.4rem;
  }
}
/deep/ table{
  width: 100%!important;
}
</style>
